<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolSelectItems"
            v-model="item.tool"
            :items="toolSelectItems"
            :error-messages="toolErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.setupdefinition.tool')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSelectItems"
            v-model="item.material"
            :items="filteredMaterialSelectItems"
            :error-messages="materialErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.setupdefinition.material')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="nozzleSelectItems"
            v-model="item.nozzle"
            :items="nozzleSelectItems"
            :error-messages="nozzleErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.setupdefinition.nozzle')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'SetupDefinitionSubForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.toolGetSelectItems();
      this.materialGetSelectItems();
      this.nozzleGetSelectItems();
      this.setupDefinitionGetSelectItems();
  },
  data() {
    return {
        tool: null,
        material: null,
        nozzle: null,
        setupDefinition: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_tool ||
         this.isLoading_material ||
         this.isLoading_setupdefinition ||
         this.isLoading_nozzle
       );
    },
      ...mapFields('tool', {
        toolSelectItems: 'selectItems',
        isLoading_tool : 'isLoading'
      }),
      ...mapFields('material', {
        materialSelectItems: 'selectItems',
        isLoading_material : 'isLoading'
      }),
      ...mapFields('nozzle', {
        nozzleSelectItems: 'selectItems',
        isLoading_nozzle : 'isLoading'
      }),
      ...mapFields('setupdefinition', {
        setupDefinitionSelectItems: 'selectItems',
        isLoading_setupdefinition : 'isLoading'
      }),

      filteredMaterialSelectItems() {
        return this.materialSelectItems.filter(material => !material.archive);
      },

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    toolErrors() {
      const errors = [];

      if (!this.$v.item.tool.$dirty) return errors;

      has(this.violations, 'tool') && errors.push(this.violations.tool);


      return errors;
    },
    materialErrors() {
      const errors = [];

      if (!this.$v.item.material.$dirty) return errors;

      has(this.violations, 'material') && errors.push(this.violations.material);


      return errors;
    },
    nozzleErrors() {
      const errors = [];

      if (!this.$v.item.nozzle.$dirty) return errors;

      has(this.violations, 'nozzle') && errors.push(this.violations.nozzle);


      return errors;
    },
    setupDefinitionErrors() {
      const errors = [];

      if (!this.$v.item.setupDefinition.$dirty) return errors;

      has(this.violations, 'setupDefinition') && errors.push(this.violations.setupDefinition);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        toolGetSelectItems: 'tool/fetchSelectItems'
      }),
      ...mapActions({
        materialGetSelectItems: 'material/fetchSelectItems'
      }),
      ...mapActions({
        nozzleGetSelectItems: 'nozzle/fetchSelectItems'
      }),
      ...mapActions({
        setupDefinitionGetSelectItems: 'setupdefinition/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      tool: {
      },
      material: {
      },
      nozzle: {
      },
      setupDefinition: {
      },
    }
  }
};
</script>
